import products from "./products";
import supply from "./supply";
import category from "./category";
import brands from "./brands";
import bcf from "./bcf";
import data from "./data";
import flashSales from "./flashSales";
import platform from "./platform";
import user from "./user";
import WHProducts from "./WHProducts";
import WHSettings from "./WHSettings";
import ebay from "./ebay"
export const API_CALLS = {
  ...products,
  ...supply,
  ...category,
  ...brands,
  ...bcf,
  ...data,
  ...flashSales,
  ...platform,
  ...user,
  ...WHProducts,
...WHSettings,
...ebay,

};
